import BaseApi from "./BaseApi";

class NotebookApi extends BaseApi {
  static getNotebook(then) {
    return this.get("/notebook/", then);
  }
}

export default NotebookApi;
